import c_4 from "../../assets/audio-screen/unit4/c_4.mp3"
import c_4_1 from "../../assets/audio-screen/unit4/c_4_1.mp3"


export const audio4 = [
   {
    'text':'Alyssa: Chào cô, đây là Tony còn thái của tôi.\nTony: Con chào cô ạ!\nMs Lê: Chào chị, chào Tony! Năm nay còn bao nhiêu tuổi?\nTony: Năm nay còn 8 tuoi a.\nAlyssa: Kia là ai vậy cô giáo Lê?\nMs Lê: đây là học sinh mới của tôi, cô ấy là Lần.\nAlyssa: Cô ấy bao nhiêu tuổi?\nMs Lê: năm nay cô ấy 10 tuoi.\n',
    'audio': c_4,
  },

];

export const audio4_1 = [
    {
     'text':'Thư ký: Xin chào ngài.\nChủ Tịch: Chào cô, hôm nay cgúng ta có một buổi họp nội bộ.\nThư ký: Vâng! Có mấy người họp cùng chúng ta ạ?\nChỉ Tích: Có 10 người, cô chuẩn bị 10  cái bút bi, 10 quyển sổ tay bảo mật.\nThư ký: Vâng, thưa ngài!\n',
     'audio': c_4_1,
   },
 
 ];